module.exports = __webpack_public_path__ + "img/index-ico7.4c2245b7.png";